module.exports = __webpack_public_path__ + "resources/img/img_prolinux8.626fb0846a2f2a2616ff1fe084f19fa7.png";